import type { BaseTranslation } from '../i18n-types';

export const chat = {
    typeMessage: 'Type your message',
    send: 'Send',
    openChat: 'Open chat',
    hideChat: 'Hide chat',
    translationIntoTip: 'Messages are automatically translated into {lang:string}',
    errors: {
        translation: 'Something went wrong and we couldn\'t translate the messages',
        containedLinks: 'Your message was modified because it contained links',
        containedProhibitedWords: 'Your message was modified because it contained prohibited words',
        containedProhibitedWordsAndLinks:
            'Your message was modified because it contained prohibited words and links',
    },
    gift: {
        requested: 'You requested a gift',
        request: 'Please give me a gift {gift:string}!',
        send: 'Send gift',
        type: {
            bear: 'Bear',
            flower: 'Flower',
            champagne: 'Champagne',
            cherry: 'Cherry',
            kiss: 'Kiss',
            ring: 'Ring',
            heart: 'Heart',
            lipstick: 'Lipstick',
            peach: 'Peach',
            eggplant: 'Eggplant',
            inLove: 'In love',
            fire: 'Fire',
            cherry2: 'Cherry',
            ghost: 'Ghost',
            pumpkin: 'Pumpkin',
            hat: 'Hat',
            chocolate: 'Chocolate',
            roses: 'Roses',
            heels: 'Heels',
            purse: 'Purse',
            lingerie: 'Lingerie',
            smartphone: 'Smartphone',
            watch: 'Watch',
            maldives: 'Maldives',
            car: 'Car',
            house: 'House',
            lollipop: 'Lollipop',
            tree: 'Tree',
            sparkler: 'Sparkler',
            tangerines: 'Tangerines',
            surprise: 'Surprise',
            snowman: 'Snowman',
            alps: 'Alps',
            loveYou: 'Love You',
            balloons: 'Balloons',
            paris: 'Paris',
            perfume: 'Perfume',
            cupid: 'Cupid',
            dinner: 'Dinner',
            sun: 'Sun',
            macarons: 'Macarons',
            brunch: 'Brunch',
            march8: '8 March',
            tulips: 'Tulips',
            picnic: 'Picnic',
            angel: 'Angel',
            basket: 'Basket',
            bouquet: 'Bouquet',
            bunny: 'Bunny',
            chocolate2: 'Chocolate',
            earrings: 'Earrings',
            easterCake: 'Cake',
            eggs: 'Eggs',
            muffins: 'Muffins',
            picnic2: 'Picnic',
            wine: 'Wine',
            hairBow: 'Hair Bow',
            letter: 'Letter',
            mirror: 'Mirror',
            magicWand: 'Magic Wand',
            mysticRose: 'Mystic Rose',
            fairyHeels: 'Fairy Heels',
            ballGown: 'Ball Gown',
            unicorn: 'Unicorn',
            carriage: 'Carriage',
            crown: 'Crown',
            castle: 'Castle',
        },
    },
} satisfies BaseTranslation;
